<template>
  <DxPopup
    v-model:visible="isVisible"
    :width="550"
    :height="217"
    :show-title="true"
    :drag-enabled="false"
    :hide-on-outside-click="false"
    :wrapper-attr="popupAttributes"
    :title="t('info_popups.title')"
  >
    <div class="popup-content">
      <div class="large-text" style="font-family: ProximaNova-Regular">
        {{ modalText }}
      </div>
      <div
        class="row"
        style="display: flex; align-self: center; margin-top: 1rem"
      >
        <DxButton
          class="orange-btn-filled"
          :text="t('common.ok')"
          :aria-label="t('common.ok')"
          width="100px"
          @click="closeModal()"
        />
      </div>
    </div>
  </DxPopup>
</template>

<script setup>
import { computed, ref } from "vue";
import store from "../../store";
import { DxPopup } from "devextreme-vue/popup";
import { DxButton } from "devextreme-vue/button";

const isVisible = computed(() => store.state.infoModal.infoModalVisible);
const modalText = computed(() => store.state.infoModal.infoModalText);
const closeModal = () => {
  store.commit("infoModal/closeInfoModal");
};
const popupAttributes = ref({
  class: "info-popup",
});
</script>
<style lang="scss">
.info-popup {
  .popup-content {
    display: flex;
    justify-content: space-around;
    margin-top: 5px;
    flex-direction: column;
    width: 100%;

    .large-text {
      font-size: 14px !important;
      display: flex;
      justify-content: center;
    }
  }
  .dx-overlay-content {
    background-color: #f1f1f1 !important;
  }
  .dx-popup-title {
    border-bottom: 1px solid #ff8500 !important;
  }
}
</style>
